import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

// Import the API client from mobile app
import { enhancedApi } from '../api/client';

// Simple login slice for web (no persistence needed)
interface LoginState {
  token: string | null;
}

const initialState: LoginState = {
  token: null,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    clearToken: (state) => {
      state.token = null;
    },
  },
});

export const { setToken, clearToken } = loginSlice.actions;

export const store = configureStore({
  reducer: {
    // API from mobile app
    [enhancedApi.reducerPath]: enhancedApi.reducer,
    // Simple auth for web
    login: loginSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      enhancedApi.middleware,
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;